import axios from 'axios';
import { ASSETS_FOLDER } from '../constants';

// ---------------------------------------------------
// Memorial
// ---------------------------------------------------

let memorialData = null;

export const getMemorialData = () =>
  new Promise((resolve, reject) => {
    if (memorialData !== null) {
      resolve(memorialData);
    } else {
      axios
        .get(`${ASSETS_FOLDER}memorial/memorial.json`)
        .then(response => {
          if (response.data && response.data.names) {
            memorialData = response.data.names;
            resolve(memorialData);
          } else {
            reject();
          }
        })
        .catch(error => {
          reject(error);
        });
    }
  });

// ---------------------------------------------------
// Info
// ---------------------------------------------------

let infoData = null;

export const getInfoData = () =>
  new Promise((resolve, reject) => {
    if (infoData !== null) {
      resolve(infoData);
    } else {
      axios
        .get(`${ASSETS_FOLDER}info/info.json`)
        .then(response => {
          if (response.data && response.data.desc) {
            infoData = response.data;
            resolve(infoData);
          } else {
            reject();
          }
        })
        .catch(error => {
          reject(error);
        });
    }
  });

// ---------------------------------------------------
// Hash
// ---------------------------------------------------

let hashInited = false;
let hash = '';

const fetchHash = () => {
  axios
    .get(
      window.location.href.indexOf('specialy') === -1
        ? '/player'
        : '/specialy/dukla61/player'
    )
    .then(response => {
      hash = response.data.split('vApp')[1].split('"')[1];
      // repeat in given interval
      setTimeout(() => {
        fetchHash();
      }, 1000 * 60 * 30);
    })
    .catch(() => {
      // note - solve error state?
      hash = 'a344b50a15436e226c2b7659a201013faeefd60a';
    });
};

export const initHash = () => {
  if (window.hash) {
    hash = window.hash;
  }
  if (!hashInited) {
    hashInited = true;
    fetchHash();
  }
};

export const getHash = () => hash;



// WEBPACK FOOTER //
// ./src/api/index.js